export default {
    'localhost:5201': {
        clientName: 'hakunamatatafooddb',
        footerLabel: 'Hakuna Matata Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Shorba', label: 'Shorba' },
            { key: 'Chinese Starters', label: 'Chinese Starters' },
            { key: 'Tandoor Starters', label: 'Tandoor Starters' },
            { key: 'Indian Starters', label: 'Indian Starters' },
            { key: 'Coastal Starters', label: 'Coastal Starters' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing',
        servicablePincodes: ["560013", "560014", "560015"],
        isShippingEnabled: true,
        restaurantPinCode: '560013'
    },
    'www.hakunamatata-restaurant.goyaana.com': {
        clientName: 'hakunamatatafooddb',
        footerLabel: 'Hakuna Matata Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Starters', label: 'Chinese Starters' },
            { key: 'Others', label: 'Others' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing',
        servicablePincodes: ["560013", "560014", "560015"],
        isShippingEnabled: true,
        restaurantPinCode: '560013'
    },
    'hakunamatata-restaurant.goyaana.com': {
        clientName: 'hakunamatatafooddb',
        footerLabel: 'Hakuna Matata Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Starters', label: 'Chinese Starters' },
            { key: 'Others', label: 'Others' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing',
        servicablePincodes: ["560013", "560014", "560015"],
        isShippingEnabled: true,
        restaurantPinCode: '560013'
    },
    'hakunamata-restaurant.goyaana.com': {
        clientName: 'hakunamatatafooddb',
        footerLabel: 'Hakuna Matata Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Starters', label: 'Chinese Starters' },
            { key: 'Others', label: 'Others' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing',
        servicablePincodes: ["560013", "560014", "560015"],
        isShippingEnabled: true,
        restaurantPinCode: '560013'
    },
    'www.basilcafemanipal-restaurant.goyaana.com': {
        clientName: 'basilcafefooddb',
        footerLabel: 'Basil Cafe Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BasilCafeManipal/logo_basilcafe.png',
        title: 'Basil Cafe Manipal',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BasilCafeManipal/logo_basilcafe.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Starters', label: 'Starters' },
            { key: 'Chinese Starters', label: 'Chinese Starters' },
            { key: 'Pastas', label: 'Pastas' },
            { key: 'Noodles and Rice', label: 'Noodles and Rice' },
            { key: 'Desserts', label: 'Desserts' },
            { key: 'Indian dishes', label: 'Indian dishes' },
            { key: 'Coolers', label: 'Coolers' },
            { key: 'Ice-Cream Shakes', label: 'Ice-Cream Shakes' },
            { key: 'Malaysian special', label: 'Malaysian special' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_BASILCAFE_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_BASILCAFE.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
    'www.countryinnmanipal-restaurant.goyaana.com': {
        clientName: 'cismanipalfooddb',
        footerLabel: 'CountryInn & Suites Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/manipal/logo.png',
        title: 'CountryInn & Suites Manipal',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/manipal/logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Exclusive Offers', label: 'Exclusive Offers' },
            { key: 'Breakfast', label: 'Breakfast' },
            { key: 'Side Orders', label: 'Side Orders' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'New Combo Special Offer', label: 'New Combo Special Offer' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Soups', label: 'Soups' },
            { key: 'Main Dish', label: 'Main Dish' },
            { key: 'South Indian Main Dish', label: 'South Indian Main Dish' },
            { key: 'RHG Signture dish', label: 'RHG Signture dish' },
            { key: 'Chinese', label: 'Chinese' },
            { key: 'Continental', label: 'Continental' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Roti', label: 'Roti' },
            { key: 'Healthy Food', label: 'Healthy Food' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Munchies', label: 'Munchies' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_COUNTRYINN_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_COUNTRYINN.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing',
        servicablePincodes: ["576104", "576107"],
        isShippingEnabled: true,
        restaurantPinCode: '576104'
    },
    'www.bsghospitality-shopping.goyaana.com': {
        clientName: 'bsghospitalitydb',
        footerLabel: 'BSG Hospitality',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BSG/logo.png',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BSG/logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Item 1', label: 'Item 1' },
            { key: 'Item 2', label: 'Item 2' },
            { key: 'Item 3', label: 'Item 3' },
            { key: 'Item 4', label: 'Item 4' },
            { key: 'Item 5', label: 'Item 5' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BSG/mobile_Image.png',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BSG/Desktop_Image.png'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1E4CO3h3pLoGBvUtV5q3_82CClmFPVGNe/edit?usp=sharing&ouid=108602667899554752637&rtpof=true&sd=true',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1nhFlQoV0N_6x1zMp8t87sJZOV-B7bVi0/edit?usp=sharing&ouid=108602667899554752637&rtpof=true&sd=true'
    },
    'www.lordshotelsjaipur-restaurant.goyaana.com': {
        clientName: 'lordsfooddb-test',
        footerLabel: 'Lords Hotels',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/LordsHotels/LordsLogo.png',
        title: 'CountryInn & Suites Manipal',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/LordsHotels/LordsLogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Exclusive Offers', label: 'Exclusive Offers' },
            { key: 'Breakfast', label: 'Breakfast' },
            { key: 'Side Orders', label: 'Side Orders' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'New Combo Special Offer', label: 'New Combo Special Offer' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Soups', label: 'Soups' },
            { key: 'Main Dish', label: 'Main Dish' },
            { key: 'South Indian Main Dish', label: 'South Indian Main Dish' },
            { key: 'RHG Signture dish', label: 'RHG Signture dish' },
            { key: 'Chinese', label: 'Chinese' },
            { key: 'Continental', label: 'Continental' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Roti', label: 'Roti' },
            { key: 'Healthy Food', label: 'Healthy Food' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Munchies', label: 'Munchies' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/LordsHotels/Jaipur/slider1.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/LordsHotels/Jaipur/slider1.jpg'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
    'www.khansamaa.goyaana.com': {
        clientName: 'khansamaafooddb',
        footerLabel: 'Khansamaa',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Khansamaa/khansamaaLogo.png',
        title: 'Khansamaa Restaurant',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Khansamaa/khansamaaLogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Khansamaa Veg Combos', label: 'Khansamaa Veg Combos' },
            { key: 'Khansamaa Non Veg Combos', label: 'Khansamaa Non Veg Combos' },
            { key: 'Biryani and Rice', label: 'Biryani and Rice' },
            { key: 'Pizza and Pasta', label: 'Pizza and Pasta' },
            { key: 'Desserts', label: 'Desserts' },
            { key: 'Fruit juices', label: 'Fruit juices' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Khansamaa/KhansamaaMobileImage.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Khansamaa/KhansamaaWebImage.jpg'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/12df6uYTzBQa5iVRJ_SU-SAJQtgIXHNHE/edit',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1E4CO3h3pLoGBvUtV5q3_82CClmFPVGNe/edit?usp=sharing&ouid=108602667899554752637&rtpof=true&sd=true',
        servicablePincodes: ["577101"],
        isShippingEnabled: true,
        restaurantPinCode: '577101'
    },
    'www.srisaicafe-experiences.goyaana.com': {
        clientName: 'srisaicafefooddb',
        footerLabel: 'SriSaiCafe',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srisaicafe/logo/Logo+sri+sai+cafe.jpg',
        title: 'SriSaiCafe Experiences',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srisaicafe/logo/Logo+sri+sai+cafe.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srisaicafe/mobileimage/burger+(1).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srisaicafe/webimage/burger+(3).jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1YvJQDXldVOf3cSXP021RLp-g2mTMQ0GS',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1YvJQDXldVOf3cSXP021RLp-g2mTMQ0GS',
        servicablePincodes: [""],
        isShippingEnabled: true,
        restaurantPinCode: ''
    },
    'www.sriudupifoodhub-jayanagar.goyaana.com': {
        clientName: 'sriudupifoodhub-jayanagardb',
        footerLabel: 'Sriudupifoodhub-jayanagar',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/sriudupilogo.png',
        title: 'Sriudupifoodhub-jayanagar',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/sriudupilogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/jayanagar/sri+jayanagar+poto.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/jayanagar/webimage.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560070"],
        isShippingEnabled: true,
        restaurantPinCode: '560070'
    },
    'www.sriudupifoodhub-kammanahalli.goyaana.com': {
        clientName: 'sriudupifoodhub_kammanahallidb',
        footerLabel: 'SriUdupiFoodHub-Kammanahalli',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/sriudupilogo.png',
        title: 'SriUdupiFoodHub-Kammanahalli',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/sriudupilogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/kammanahalli/sriudupi-mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/kammanahalli/sriudupi-kammanahalli-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560084"],
        isShippingEnabled: true,
        restaurantPinCode: '560084'
    },
    'www.sriudupifoodhub-vijayanagar.goyaana.com': {
        clientName: 'sriudupifoodhub-vijayanagardb',
        footerLabel: 'SriUdupiFoodHub-Vijayanagar',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/sriudupilogo.png',
        title: 'SriUdupiFoodHub-Vijayanagar',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/sriudupilogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/vijayanagar/mobile/udupi+(1).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/vijayanagar/web+image/udupi+(2).jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560040"],
        isShippingEnabled: true,
        restaurantPinCode: '560040'
    },
    'www.theredbox.goyaana.com': {
        clientName: 'theredboxfooddb',
        footerLabel: 'TheRedBox',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theredbox/theredboxlogo.png',
        title: 'TheRedBox',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theredbox/theredboxlogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Momos', label: 'Momos' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Combo', label: 'Combo' },
            { key: 'Specials Gravy', label: 'Specials Gravy' },
            { key: 'Desserts', label: 'Desserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theredbox/theredbox-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theredbox/theredbox-mob+(1).jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: ''
    },
    'www.pepespizza.goyaana.com': {
        clientName: 'pepespizzafooddb',
        footerLabel: 'Pepespizza',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pepespizza/logo/plogo.png',
        title: 'Pepespizza',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pepespizza/logo/plogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Combos', label: 'Combos' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Pastas', label: 'Pastas' },
            { key: 'Twisties', label: 'Twisties' },
            { key: 'Desi Tacos', label: 'Desi Tacos' },
            { key: 'Burgers', label: 'Burgers' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Beverages', label: 'Beverages' },
            { key: 'Desserts', label: 'Desserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pepespizza/mobileimage/pizza+(1).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pepespizza/laptopimage/pizza+(2).jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1bMNqktKjpCO8bukzyoIRz4lA-QzlQGy7',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1bMNqktKjpCO8bukzyoIRz4lA-QzlQGy7'
    },
    'www.madhurikitchenmk.goyaana.com': {
        clientName: 'madhurikitchenmkfooddb',
        footerLabel: 'madhurikitchenmk',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhurikitchenmk/Logo.png',
        title: 'madhuri kitchen MK',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhurikitchenmk/Logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'VADA', label: 'VADA' },
            { key: 'IDLI', label: 'IDLI' },
            { key: 'DOSA', label: 'DOSA' },
            { key: 'TEA', label: 'TEA' },
            { key: 'TIFFIN', label: 'TIFFIN' },
            { key: 'RICE', label: 'RICE' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhurikitchenmk/ezgif.com-gif-maker+(1)+(1).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhurikitchenmk/ezgif.com-gif-maker.jpg'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1oBGwqghSxxp99DUZxvuJY4dgjZB0RoLd/edit#',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1quZSA8wcjQZSbGi_wtMLN7HF0JUtP2hh/edit',
        servicablePincodes: ["560037"],
        isShippingEnabled: false,
        restaurantPinCode: '560037'
    },
    'www.pingara.goyaana.com': {
        clientName: 'pingarafooddb',
        footerLabel: 'pingara',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pingara/pingaralogo.png',
        title: 'Pingara',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pingara/pingaralogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Neer Dosa', label: 'Neer Dosa' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Soups', label: 'Soups' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pingara/pingaramobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/pingara/pingaraweb.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1Yks-NQNdRdrIvgqE-hMgiHJB_YPRj1Cu',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1Yks-NQNdRdrIvgqE-hMgiHJB_YPRj1Cu',
        servicablePincodes: [""],
        isShippingEnabled: true,
        restaurantPinCode: ''
    },
    'www.newaaharrestaurant.goyaana.com': {
        clientName: 'newaaharrestaurantfooddb',
        footerLabel: 'newaaharrestaurant',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/aaharrestaurant/logo/aa.jpeg',
        title: 'Newaahar Restaurant',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/aaharrestaurant/logo/aa.jpeg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/aaharrestaurant/mobile/mm+(1).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/aaharrestaurant/laptop/curd+(1).jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1nrmZYYsxwuEbn9qzEeAv8Tt1qIVtcoEO',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1nrmZYYsxwuEbn9qzEeAv8Tt1qIVtcoEO',
        servicablePincodes: ["560076"],
        isShippingEnabled: true,
        restaurantPinCode: '560076'
    },
    'www.sriudupifoodhub-nallurahalli.goyaana.com': {
        clientName: 'sriudupifoodhub-nallurahallifooddb',
        footerLabel: 'sriudupifoodhub-nallurahalli',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/nallurahalli/fINAL+Udupi+hotel+Logo-1.png',
        title: 'SriUdupifoodhub-Nallurahalli',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/nallurahalli/fINAL+Udupi+hotel+Logo-1.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Brakfast', label: 'Breakfast' },
            { key: 'Sandwich', label: 'Sandwich' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Tandoori starters', label: 'Tandoori starters' },
            { key: 'Chinese starters', label: 'Chinese starters' },
            { key: 'Chats', label: 'Chats' },
            { key: 'Indian Bread', label: 'Indian Bread' },
            { key: 'Tawa Ka Kamal', label: 'Tawa Ka Kamal' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Chinese special', label: 'Chinese special' },
            { key: 'Chinese rice', label: 'Chinese rice' },
            { key: 'Chopsy', label: 'Chopsy' },
            { key: 'Melas', label: 'Meals' },
            { key: 'Basumathi Special', label: 'Basumathi Special' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/nallurahalli/food-mobi.png',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sriudupifoodhub/nallurahalli/food+image.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1664hibRsiQ5ACYYh9OCswCRqScJvmqaj',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1664hibRsiQ5ACYYh9OCswCRqScJvmqaj',
        servicablePincodes: ["560066"],
        isShippingEnabled: true,
        restaurantPinCode: '560066'
    },
    'www.abhiruchi.goyaana.com': {
        clientName: 'abhiruchifooddb',
        footerLabel: 'abhiruchi',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/abhiruchi/Abhiruchi-logo.png',
        title: 'Abhi Ruchi',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/abhiruchi/Abhiruchi-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Starters', label: 'Starters' },
            { key: 'Chinese', label: 'Chinese' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/abhiruchi/abhiruchi-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/abhiruchi/abhiruchi-web.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1664hibRsiQ5ACYYh9OCswCRqScJvmqaj',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1664hibRsiQ5ACYYh9OCswCRqScJvmqaj'
    },
    'www.saihealthyfood.goyaana.com': {
        clientName: 'saihealthyfooddb',
        footerLabel: 'saihealthyfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srihealthy+food/sailogo.png',
        title: 'saihealthyfood',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srihealthy+food/sailogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Crispy Bites', label: 'Crispy Bites' },
            { key: 'Maggi Homemade', label: 'Maggi Homemade' },
            { key: 'Momos', label: 'Momos' },
            { key: 'Samosa', label: 'Samosa' },
            { key: 'Sweet Corn', label: 'Sweet Corn' },
            { key: 'Curd Varieties', label: 'Curd Varieties' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Burger', label: 'Burger' },
            { key: 'Homemade', label: 'Homemade' },
            { key: 'Milkshakes', label: 'Milkshakes' },
            { key: 'Pancake homemade', label: 'Pancake homemade' },
            { key: 'Sandwich', label: 'Sandwich' },
            { key: 'Crushers', label: 'Crushers' },
            { key: 'Deserts', label: 'Deserts' },
            { key: 'Midday meal homemade', label: 'Midday meal homemade' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srihealthy+food/srihealthymob.jpeg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/srihealthy+food/srihealthy+web.jpeg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1qD-2_Aj4oMIS6N0sdJgyWxDY5DWNMbgN',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1qD-2_Aj4oMIS6N0sdJgyWxDY5DWNMbgN',
        servicablePincodes: [ "560077", "560010", "560040", "560083", "560038", "560041"],
        isShippingEnabled: true,
        restaurantPinCode: '560077'
    },
    'www.thayeetouch.goyaana.com': {
        clientName: 'thayeetouchfooddb',
        footerLabel: 'thayeetouchfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thayee+touch/thayee+touch+logo.png',
        title: 'thayeetouchfood',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thayee+touch/thayee+touch+logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Sukka', label: 'Sukka' },
            { key: 'Fish Fry', label: 'Fish Fry' },
            { key: 'Our Karavali SPL Dishes', label: 'Our Karavali SPL Dishes' },
            { key: 'Our Best Dry Items', label: 'Our Best Dry Items' },
            { key: 'Pepper Dries', label: 'Pepper Dries' },
            { key: 'Vegetarian Dry', label: 'Vegetarian Dry' },
            { key: 'Chinese Dishes Dry Boneless', label: 'Chinese Dishes Dry Boneless' },
            { key: 'Non-Veg Dry with Bone', label: 'Non-Veg Dry with Bone' },
            { key: 'Veg in Masala (Gravy)', label: 'Veg in Masala (Gravy)' },
            { key: 'Indian SPL Gravy Chicken', label: 'Indian SPL Gravy Chicken' },
            { key: 'Biryani/ Pulav/ Rice', label: 'Biryani/ Pulav/ Rice' },
            { key: 'Fried Rice', label: 'Fried Rice' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thayee+touch/thayee+touch+mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thayee+touch/thayee+touch+web.jpg'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1lMxbOxzkYsj8ehYDqaKeVvYA1pABsFxf/edit',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1hptGcADezQR49Q1J8SOL6lFJ63p2UnzV/edit?rtpof=true',
        servicablePincodes: ["560078"],
        isShippingEnabled: true,
        restaurantPinCode: '560078'
    },
    'www.rocklandhotels-tamarind.goyaana.com': {
        clientName: 'rocklandfooddb',
        footerLabel: 'rocklandfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/rockland/logo/rk-logo.jpg',
        title: 'rockland',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/rockland/logo/rk-logo.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups and Salads', label: 'Soups and Salads'},
            { key: 'Appetizers', label: 'Appetizers' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Rice and Biriyani', label: 'Rice and Biriyani' },
            { key: 'Pasta', label: 'Pasta' },
            { key: 'Accompaniments', label: 'Accompaniments' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/rockland/mob/mob+(1).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/rockland/web/web+(1).jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1_MFnUCt93084uk61WdFrj0oJv1FFDsEU',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1_MFnUCt93084uk61WdFrj0oJv1FFDsEU',
        servicablePincodes: ["110019"],
        isShippingEnabled: true,
        restaurantPinCode: '110019'
    },
    'www.hadika-restaurant.goyaana.com': {
        clientName: 'hadikafooddb',
        footerLabel: 'hadikafood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/hadika/hadika+logo.png',
        title: 'Hadika Restaurant',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/hadika/hadika+logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Starters', label: 'Starters'},
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Omelettes', label: 'Omelettes' },
            { key: 'Beverages', label: 'Beverages' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/hadika/hadika+mob.jpeg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/hadika/hadika+web+image.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1_MFnUCt93084uk61WdFrj0oJv1FFDsEU',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1_MFnUCt93084uk61WdFrj0oJv1FFDsEU'
    },
    'www.eyeofthetiger.goyaana.com': {
        clientName: 'eyeofthetigerfooddb',
        footerLabel: 'eyeofthetigerfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/eyeofthetiger/eyeofthetiger-logo.png',
        title: 'eye of the tiger',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/eyeofthetiger/eyeofthetiger-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Wings', label: 'Wings'},
            { key: 'Pasta', label: 'Pasta' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Indian Curry', label: 'Indian Curry' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/eyeofthetiger/mob+image.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/eyeofthetiger/web+image.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: ''
    },
    'www.dollops.goyaana.com': {
        clientName: 'dollopsfooddb',
        footerLabel: 'dollopsfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/dollops/logo.png',
        title: 'dollops',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/dollops/logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Starters', label: 'Starters'},
            { key: 'Soups and Salads', label: 'Soups and Salads' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Momos', label: 'Momos' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/dollops/mob+image.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/dollops/web+image.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1_MFnUCt93084uk61WdFrj0oJv1FFDsEU',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1_MFnUCt93084uk61WdFrj0oJv1FFDsEU'
    },
    'www.tajdarbar.goyaana.com': {
        clientName: 'tajdarbarfooddb',
        footerLabel: 'tajdarbarfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/tajdarbar/tajdarbar-logo.png',
        title: 'tajdarbar',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/tajdarbar/tajdarbar-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Starters', label: 'Starters'},
            { key: 'Tandoor Ka Khazana', label: 'Tandoor Ka Khazana' },
            { key: 'Shawarma', label: 'Shawarma' },
            { key: 'Taj darbar spl boneless', label: 'Taj darbar spl boneless' },
            { key: 'Chicken mughlai dishes', label: 'Chicken mughlai dishes' },
            { key: 'Roti & Naan', label: 'Roti & Naan' },
            { key: 'Gravy', label: 'Gravy' },
            { key: 'Rice/Noodles', label: 'Rice/Noodles' },
            { key: 'Non veg biryani', label: 'Non veg biryani' },
            { key: 'Basmati Ka Kamal', label: 'Basmati Ka Kamal' },
            { key: 'Mutton dishes', label: 'Mutton dishes' },
            { key: 'Desserts', label: 'Desserts' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/tajdarbar/tajdarbar-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/tajdarbar/tajdarbar-web.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1qwsTvYj6RKOYBLpdGIx20PZbp9xUQP5G?usp=sharing',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1qwsTvYj6RKOYBLpdGIx20PZbp9xUQP5G?usp=sharing',
        servicablePincodes: ["400086"],
        isShippingEnabled: true,
        restaurantPinCode: '400086'
    },
    'www.aramanedonnebiryani.goyaana.com': {
        clientName: 'aramanedonnefooddb',
        footerLabel: 'aramanedonnebiryanifood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/donne/donne-logo.png',
        title: 'aramane donne biryani',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/donne/donne-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Salad', label: 'Salad' },
            { key: 'Snack', label: 'Snack' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Biryani Mahal', label: 'Biryani Mahal' },
            { key: 'Chicken Khazana', label: 'Chicken Khazana' },
            { key: 'Currys Khazana', label: 'Currys Khazana' },
            { key: 'Mutton Khazana', label: 'Mutton Khazana' },
            { key: 'Tandoori', label: 'Tandoori' },
            { key: 'Veg Curry', label: 'Veg Curry' },
            { key: 'Egg Khazana', label: 'Egg Khazana' },
            { key: 'Grill', label: 'Grill' },
            { key: 'Noodels', label: 'Noodels' },
            { key: 'Veg Khazana', label: 'Veg Khazana' },
            { key: 'Sea Food', label: 'Sea Food' },
            { key: 'ADB Special Combos', label: 'ADB Special Combos' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Fried Rice and Noodles', label: 'Fried Rice and Noodles' },
            { key: 'Accompaniments', label: 'Accompaniments' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/donne/donne-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/donne/donne-web.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1GYNrnrLENjVubsHPhi9zQKZk_VyZ9WEf?usp=sharing',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1GYNrnrLENjVubsHPhi9zQKZk_VyZ9WEf?usp=sharing',
        servicablePincodes: ["560061","560076"],
        isShippingEnabled: true,
        restaurantPinCode: '560061'
    },
    'www.ctfmanipal.goyaana.com': {
        clientName: 'ctfmanipalfooddb',
        footerLabel: 'ctfmanipalfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/ctfmanipal/ctf+manipal+logo.png',
        title: 'ctf manipal',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/ctfmanipal/ctf+manipal+logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Starters', label: 'Starters' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Rice and Biriyani', label: 'Rice and Biriyani' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Chinese', label: 'Chinese' },
            { key: 'Deserts', label: 'Deserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/ctfmanipal/ctf+mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/ctfmanipal/ctf+web.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1GYNrnrLENjVubsHPhi9zQKZk_VyZ9WEf?usp=sharing',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1GYNrnrLENjVubsHPhi9zQKZk_VyZ9WEf?usp=sharing'
    },
    'www.shackfoods.goyaana.com': {
        clientName: 'shackfoodsfooddb',
        footerLabel: 'shackfoodsfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/shackfoods/shackfoods-logo.png',
        title: 'shack foods',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/shackfoods/shackfoods-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Burger', label: 'Burger' },
            { key: 'Wraps', label: 'Wraps' },
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Salad', label: 'Salad' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Pastry', label: 'Pastry' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/shackfoods/shackfoods-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/shackfoods/shackfoods-web.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1O6xRSFezziF5ZEIM2p3UgZlRKpEP27Ry?usp=sharing',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1O6xRSFezziF5ZEIM2p3UgZlRKpEP27Ry?usp=sharing',
        servicablePincodes: ["110003"],
        isShippingEnabled: true,
        restaurantPinCode: '110003'
    },
    'www.teapotcafe.goyaana.com': {
        clientName: 'teapotcafefooddb',
        footerLabel: 'teapotcafefood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/teapotcafe/teapotlogo.png',
        title: 'teapot cafe',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/teapotcafe/teapotlogo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Burger', label: 'Burger' },
            { key: 'Wraps', label: 'Wraps' },
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Salad', label: 'Salad' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Pastry', label: 'Pastry' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/teapotcafe/mob.032.jpeg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/teapotcafe/web+image.jpg'
        },
        privacyPolicyLink: 'https://drive.google.com/drive/folders/1O6xRSFezziF5ZEIM2p3UgZlRKpEP27Ry?usp=sharing',
        termsAndConditionsLink: 'https://drive.google.com/drive/folders/1O6xRSFezziF5ZEIM2p3UgZlRKpEP27Ry?usp=sharing'
    },
    'www.madhuvanrestaurant.goyaana.com': {
        clientName: 'madhuvanfooddb',
        footerLabel: 'madhuvanrestaurantfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhuvan/madhuvan-logo.png',
        title: 'madhuvan restaurant',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhuvan/madhuvan-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Burger', label: 'Burger' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Indian Breads', label: 'Indian Breads' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Chinese Rice', label: 'Chinese Rice' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhuvan/madhuvan-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhuvan/madhuvan-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: ''
    },
    'www.fiaslounge.goyaana.com': {
        clientName: 'fiasloungefooddb',
        footerLabel: 'fiasloungefood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Fiaslounge/Fias-logo.png',
        title: 'fiaslounge',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhuvan/madhuvan-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Appetizers', label: 'Appetizers' },
            { key: 'Salads', label: 'Salads'},
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Desserts', label: 'Desserts' },
            { key: 'Beverages', label: 'Beverages' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Fiaslounge/fias-mob+(2).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Fiaslounge/fias-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560025"],
        isShippingEnabled: true,
        restaurantPinCode: '560025'
    },
    'www.empirerestaurant.goyaana.com': {
        clientName: 'empirerestaurantfooddb',
        footerLabel: 'empirerestaurantfood',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/empire-restaurant/empire-logo.png',
        title: 'empire restaurant',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/madhuvan/madhuvan-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Classic(Dry)', label: 'Classic(Dry)' },
            { key: 'Noodles', label: 'Noodles' },
            { key: 'Parota', label: 'Parota' },
            { key: 'Egglicious', label: 'Egglicious' },
            { key: 'Dosa', label: 'Dosa'},
            {key: 'Gravy', label: 'Gravy' },
            { key: 'Rice', label: 'Rice' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/empire-restaurant/mobi-header.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/empire-restaurant/header.gif'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560077", "560010"],
        isShippingEnabled: true,
        restaurantPinCode: '560077'
    },
    'www.nandhanapalace.goyaana.com': {
        clientName: 'nandhanafooddb',
        footerLabel: 'nandhanapalace',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/nandhana+palace/Nandhana-logo.png',
        title: 'nandhana palace',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/nandhana+palace/Nandhana-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Lip Smacking Starters', label: 'Lip Smacking Starters' },
            { key: 'Immunity Boosters', label: 'Immunity Boosters' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Rice & Noodles', label: 'Rice & Noodles' },
            { key: 'Acclaimed Biryanis', label: 'Acclaimed Biryanis' },
            { key: 'Desserts', label: 'Desserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/nandhana+palace/Nandhana-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/nandhana+palace/Nandhana-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: [""],
        isShippingEnabled: true,
        restaurantPinCode: ''
    },
    'www.thalasseryrestaurant.goyaana.com': {
        clientName: 'thalasseryfooddb',
        footerLabel: 'thalasseryrestaurant',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thalasseryrestaurant/thalassery-logo.png',
        title: 'thalassery restaurant',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thalasseryrestaurant/thalassery-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thalasseryrestaurant/thalassery-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/thalasseryrestaurant/thalassery-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: ''
    },
    'www.chickpetdonnebiryanihouse-byrathi.goyaana.com': {
        clientName: 'Chickpetdonnebiryanihousefooddb',
        footerLabel: 'Chickpetdonnebiryanihouse',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chickpetdonnebiryanihouse/cdbh+logo.png',
        title: 'Chickpet donne biryani house-byrathi',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chickpetdonnebiryanihouse/cdbh+logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Veg Starters', label: 'Veg Starters' },
            { key: 'Chicken Starters', label: 'Chicken Starters' },
            { key: 'Sea Food', label: 'Sea Food' },
            { key: 'Mutton Starters', label: 'Mutton Starters' },
            { key: 'Egg Starters', label: 'Egg Starters' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Veg Main & Chinese Course', label: 'Veg Main & Chinese Course' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chickpetdonnebiryanihouse/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chickpetdonnebiryanihouse/web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560077", "560010"],
        isShippingEnabled: true,
        restaurantPinCode: '560077'
    },
    'www.darjeelingsfoods.goyaana.com': {
        clientName: 'darjeelingsfooddb',
        footerLabel: 'darjeelingsfoods',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/darjeeling+restaurant/logo.png',
        title: 'darjeelings foods',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/darjeeling+restaurant/logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/darjeeling+restaurant/darjling.mob.jpeg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/darjeeling+restaurant/darling.web.jpeg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: ''
    },
    'www.leongrill.goyaana.com': {
        clientName: 'leongrillfooddb',
        footerLabel: 'leongrill',
        logo: 'https://s3.ap-southeast-1.amazonaws.com/www.ourtourplanner.com/leongrill/leongrill.png',
        title: 'leongrill',
        favIconUrl: 'https://s3.ap-southeast-1.amazonaws.com/www.ourtourplanner.com/leongrill/leongrill.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://s3.ap-southeast-1.amazonaws.com/www.ourtourplanner.com/leongrill/leongrill-mobile.jpg',
            webImgUrl:'https://s3.ap-southeast-1.amazonaws.com/www.ourtourplanner.com/leongrill/leongrill-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: ''
    },
    'www.arabianmexicofamilyrestaurant.goyaana.com': {
        clientName: 'arabianmexicofooddb',
        footerLabel: 'arabianmexico',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/arabianmexico/mexico+logo.png',
        title: 'arabian mexico',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/arabianmexico/mexico+logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'item 1', label: 'item 1' },
            { key: 'item 2', label: 'item 2' },
            { key: 'item 3', label: 'item 3' },
            { key: 'item 4', label: 'item 4' },
            { key: 'item 5', label: 'item 5' },
            { key: 'item 6', label: 'item 6' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/arabianmexico/arabian.mob.jpeg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/arabianmexico/arabian.web.jpeg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: [""],
        isShippingEnabled: true,
        restaurantPinCode: ''
    },
    'www.belgianwafflefactory-whitefield.goyaana.com': {
        clientName: 'belgianwafflefooddb',
        footerLabel: 'belgianwafflefactory',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/belgianwaffle/EBD74D14-0C36-48D0-822A-C55BADA1FCE6+-+shreyas+yadav+(shreyUuu).png',
        title: 'Belgian waffle factory',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/belgianwaffle/EBD74D14-0C36-48D0-822A-C55BADA1FCE6+-+shreyas+yadav+(shreyUuu).png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Bubble Waffles', label: 'Bubble Waffles' },
            { key: 'Sandwich Waffles', label: 'Sandwich Waffles' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/belgianwaffle/mobile-waffle.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/belgianwaffle/lap-waffle.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560067", "560010"],
        isShippingEnabled: true,
        restaurantPinCode: '560067'
    },
    'www.experiences.goyaana.com': {
        clientName: 'experiencesfooddb',
        footerLabel: 'experiences',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Experiences/logo.png',
        title: 'Experiences',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Experiences/logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Business Hotels', label: 'Business Hotels' },
            { key: 'Leisure Hotels', label: 'Leisure Hotels' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Experiences/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Experiences/web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: [""],
        isShippingEnabled: true,
        restaurantPinCode: ''
    },
    'www.royalorchid-9thmiledhaba.goyaana.com': {
        clientName: 'Royalorchid-9thMiledhabafooddb',
        footerLabel: 'royalorchid-9thmiledhaba',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Royal-orchid/png.png',
        title: 'Royal Orchid',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Royal-orchid/png.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Starters', label: 'Starters' },
            { key: 'Rice and Biryani', label: 'Rice and Biryani' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Desserts', label: 'Desserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Royal-orchid/phone.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Royal-orchid/laptop.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560065", "560010"],
        isShippingEnabled: true,
        restaurantPinCode: '560065'
    },
    'www.simplyindian.goyaana.com': {
        clientName: 'simplyindianfooddb',
        footerLabel: 'SimplyIndian',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Simply+Indian/simply-indian.png',
        title: 'Simply Indian',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Simply+Indian/simply-indian.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups and Salad', label: 'Soups and Salad' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Rolls', label: 'Rolls' },
            { key: 'Snacks and Chaat', label: 'Snacks and Chaat' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Rice and Biryani', label: 'Rice and Biryani' },
            { key: 'Fried Rice and Noodles', label: 'Fried Rice and Noodles' },
            { key: 'Desserts', label: 'Desserts' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Simply+Indian/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Simply+Indian/web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560065", "560010"],
        isShippingEnabled: true,
        restaurantPinCode: '560065'
    },
    'www.theblackpearl.goyaana.com': {
        clientName: 'theblackpearlfooddb',
        footerLabel: 'TheBlackPearl',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theblackpearl/blackpearl.png',
        title: 'The Black Pearl',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theblackpearl/blackpearl.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'NonVeg Starters', label: 'NonVeg Starters' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Chefs Special Biryani', label: 'Chefs Special Biryani' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Recommended', label: 'Recommended' } 
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theblackpearl/mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/theblackpearl/laptop.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560103"],
        isShippingEnabled: true,
        restaurantPinCode: '560103'
    },
    'www.drinkanddine.goyaana.com': {
        clientName: 'drinkanddinefooddb',
        footerLabel: 'Drink&Dine',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/drinkanddine/drink%26dine-logo.png',
        title: 'Drink and Dine',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/drinkanddine/drink%26dine-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups ', label: 'Soups ' },
            { key: 'Sandwich', label: 'Sandwich' },
            { key: 'Veg Starters', label: 'Veg Starters' },
            { key: 'Non Veg Starters', label: 'Non Veg Starters' },
            { key: 'Egg Special', label: 'Egg Special' },
            { key: 'DND Special Salad', label: 'DND Special Salad' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Indian Breads', label: 'Indian Breads' },
            { key: 'Rice ', label: 'Rice ' },
            { key: 'Special Biryani', label: 'Special Biryani' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/drinkanddine/mobi.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/drinkanddine/lap.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560040"],
        isShippingEnabled: true,
        restaurantPinCode: '560040'
    },
    'www.granddesiparatha.goyaana.com': {
        clientName: 'granddesiparathafooddb',
        footerLabel: 'Grand Desi Paratha',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/grand-desi-paratha/Grand-Desi-Taratha-logo.png',
        title: 'Grand Desi Paratha',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/grand-desi-paratha/Grand-Desi-Taratha-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Indian Parathzza', label: 'Indian Parathzza' },
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Appetizer', label: 'Appetizer' },
            { key: 'Soup Special', label: 'Soup Special' },
            { key: 'Stuffed Paratha', label: 'Stuffed Paratha' },
            { key: 'Hot Beverage', label: 'Hot Beverage' },
            { key: 'Milk Blends', label: 'Milk Blends' },
            { key: 'Cold Blends', label: 'Cold Blends' },
            { key: 'GDP Special Roll', label: 'GDP Special Roll' },
            { key: 'Indian Tacos', label: 'Indian Tacos' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Rice', label: 'Rice' },
            { key: 'GDP Combos', label: 'GDP Combos' },
            { key: 'North Indian Thali', label: 'North Indian Thali' },
            { key: 'Indian Gravy', label: 'Indian Gravy' },
            { key: 'Yogurt Blends', label: 'Yogurt Blends' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Indian Breads Add On', label: 'Indian Breads Add On' },
            { key: 'Tandoori', label: 'Tandoori' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/grand-desi-paratha/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/grand-desi-paratha/desktop.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560065", "560010"],
        isShippingEnabled: true,
        restaurantPinCode: '560065'
    },
    'www.sgs-non-veg-gundu-palav-kanakapura-road.goyaana.com': {
        clientName: 'sgsnonvegfooddb',
        footerLabel: 'SGS Non-Veg Gundu Palav',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/SGS.jpg',
        title: 'sgs-non-veg-gundu-palav',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/SGS.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Non Veg Gundu Palav', label: 'Non Veg Gundu Palav' },
            { key: 'Recommended', label: 'Recommended' },
            { key: 'Combos', label: 'Combos' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Family Feast', label: 'Family Feast' },
            { key: 'Drinks (Beverages)', label: 'Drinks (Beverages)' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560062", "560062"],
        isShippingEnabled: true,
        restaurantPinCode: '560062'
    },
    'www.lakshmi-sagar-deluxe.goyaana.com': {
        clientName: 'lakshmisagarfooddb',
        footerLabel: 'lakshmisagardeluxe',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lakshmi-sagar/lakshmisagar.png',
        title: 'LakshmiSagarDeluxe',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lakshmi-sagar/lakshmisagar.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Snacks', label: 'Snacks' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Rice and Biryani', label: 'Rice and Biryani' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lakshmi-sagar/laxshmi-sagar-mobi.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lakshmi-sagar/laxshmi-sagar.gif'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560070"],
        isShippingEnabled: true,
        restaurantPinCode: '560070'
    },
    'www.fortunehotels-sleep-boutique.goyaana.com': {
        clientName: 'sleeepboutiquefooddb',
        footerLabel: 'sleeepboutique',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sleeep+Boutique/sleeep+logo.jpg',
        title: 'sleepboutique',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sleeep+Boutique/sleeep+logo.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pillows', label: 'Pillows' },
            { key: 'Bed Linen', label: 'Bed Linen' },
            { key: 'Embroidered Bed Linen', label: 'Embroidered Bed Linen' },
            { key: 'Duvet', label: 'Duvet' },
            { key: 'Infant Collection', label: 'Infant Collection' },
            { key: 'Mattress Protector', label: 'Mattress Protector' },
            { key: 'Curated Combo Sets', label: 'Curated Combo Sets' },
            { key: 'Sleeep Boutique Qutlets', label: 'Sleeep Boutique Qutlets' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sleeep+Boutique/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sleeep+Boutique/web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560070"],
        isShippingEnabled: true,
        restaurantPinCode: '560070'
    },
    'www.chicking-hsr.goyaana.com': {
        clientName: 'chickinghsrfooddb',
        footerLabel: 'chicking-hsr',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking-hsr/hsr+logo.jpg',
        title: 'chicking-hsr',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking-hsr/hsr+logo.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Bucket Offers', label: 'Bucket Offers' },
            { key: 'Happy Treats', label: 'Happy Treats' },
            { key: 'Super Six', label: 'Super Six' },
            { key: 'Sides', label: 'Sides' },
            { key: 'Strip Delight', label: 'Strip Delight' },
            { key: 'Value Pack', label: 'Value Pack' },
            { key: 'Twisty Gala', label: 'Twisty Gala' },
            { key: 'Royal Bliss And Crunchy', label: 'Royal Bliss And Crunchy' },
            { key: 'Booster Pack', label: 'Booster Pack' },
            { key: 'Masti Bites', label: 'Masti Bites' },
            { key: 'Wraps Special Combo', label: 'Wraps Special Combo' },
            { key: 'Burgers Special Combo', label: 'Burgers Special Combo' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking-hsr/hsr+landing+(2).jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking-hsr/hsr+landing+(1).jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560034"],
        isShippingEnabled: true,
        restaurantPinCode: '560034'
    },
    'www.chicking-marathahalli.goyaana.com': {
        clientName: 'chickingmarthfooddb',
        footerLabel: 'chicking-marathahalli',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking+marthahalli/chicking-logo.jpg',
        title: 'Chicking-Marathahalli',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking+marthahalli/chicking-logo.jpg',
        resetPasswordUrl: '',
        menuItems: [
        { key: 'Side Items', label: 'Side Items' },
        { key: 'Mini Bites', label: 'Mini Bites' },
        { key: 'Spiced Bites', label: 'Spiced Bites' },
        { key: 'Veggie Corner', label: 'Veggie Corner' },
        { key: 'Soho Rice', label: 'Soho Rice' },
        { key: 'Pizza', label: 'Pizza' },
        { key: 'Combo Bites', label: 'Combo Bites' },
        { key: 'Supreme Meals', label: 'Supreme Meals' },
        { key: 'Bucket Meals', label: 'Bucket Meals' },
        { key: 'Extras', label: 'Extras' },
        { key: 'Beverages', label: 'Beverages' },
        { key: 'Family Meals', label: 'Family Meals' }, 
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking+marthahalli/chicking-mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/chicking+marthahalli/chicking-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560037"],
        isShippingEnabled: true,
        restaurantPinCode: '560037'
    },
    'www.brunchilly.goyaana.com': {
        clientName: 'brunchillyfooddb',
        footerLabel: 'Brunchilly',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Brunchilly/logo.png',
        title: 'Brunchilly',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Brunchilly/logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Biryani', label: 'Biryani' },
            { key: 'Fried Rice and Noodles', label: 'Fried Rice and Noodles' },
            { key: 'Mains', label: 'Mains' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Short Eats', label: 'Short Eats' },
            { key: 'Rolls', label: 'Rolls' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Brunchilly/mobi.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Brunchilly/lap.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560037"],
        isShippingEnabled: true,
        restaurantPinCode: '560037'
    },
    'www.indipizza.goyaana.com': {
        clientName: 'indipizzafooddb',
        footerLabel: 'Indipizza',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Indipizza/Indipizza-logo.png',
        title: 'Indipizza',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Indipizza/Indipizza-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizza', label: 'Pizza' },
            { key: 'Combo Deals', label: 'Combo Deals' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Pasta', label: 'Pasta' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Indipizza/mobi.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Indipizza/lap.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560066"],
        isShippingEnabled: true,
        restaurantPinCode: '560066'
    },
    'www.savi-sagar-grand.goyaana.com': {
        clientName: 'savifooddb',
        footerLabel: 'savi-sagar-grand',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/savi-sagar-grand/svglogo.jpeg',
        title: 'savi-sagar-grand',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/savi-sagar-grand/svglogo.jpeg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Soups', label: 'Soups' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'Drinks (Beverages)', label: 'Drinks (Beverages)' },
            { key: 'Desserts ', label: 'Desserts ' },
            { key: 'Accompaniments', label: 'Accompaniments' },
            { key: 'Snacks and Chaat', label: 'Snacks and Chaat' },
            { key: 'Fried Rice and Noodles', label: 'Fried Rice and Noodles' },
            { key: 'Chinese', label: 'Chinese' },
            { key: 'Dosa', label: 'Dosa' },
            { key: 'South Indian ', label: 'South Indian' },
            { key: 'Rice and Biryani', label: 'Rice and Biryani' },
            { key: 'Breads', label: 'Breads' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/savi-sagar-grand/savi-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/savi-sagar-grand/savi-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560076"],
        isShippingEnabled: true,
        restaurantPinCode: '560076'
    },
    'www.sanaas.goyaana.com': {
        clientName: 'sanaasfooddb',
        footerLabel: 'Sanaas',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sanaas/sanaas-logo.png',
        title: 'Sanaas',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sanaas/sanaas-logo.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Tandoori Veg', label: 'Tandoori Veg' },
            { key: 'Tandoori Chicken', label: 'Tandoori Chicken' },
            { key: 'Tandoori Seafood', label: 'Tandoori Seafood' },
            { key: 'Main Course Veg', label: 'Main Course Veg' },
            { key: 'Main Course Chicken', label: 'Main Course Chicken' },
            { key: 'Main Course Mutton', label: 'Main Course Mutton' },
            { key: 'Biriyani', label: 'Biriyani' },
            { key: 'Starters Veg', label: 'Starters Veg' },
            { key: 'Starters Chicken', label: 'Starters Chicken' },
            { key: 'Starters Seafood', label: 'Starters Seafood' },
            { key: 'MainCourse Veg', label: 'MainCourse Veg' },
            { key: 'MainCourse Chicken', label: 'MainCourse Chicken' },
            { key: 'MainCourse Seafood', label: 'MainCourse Seafood' },
            { key: 'MainCourse Mutton', label: 'MainCourse Mutton' },
            { key: 'Soups', label: 'Soups' },
            { key: 'Thukpa (Noodle Soup)', label: 'Thukpa (Noodle Soup)' },
            { key: 'Momos', label: 'Momos' },
            { key: 'Starters Veg(Chinese Cuisine)', label: 'Starters Veg(Chinese Cuisine)' },
            { key: 'Starters Chicken(Chinese Cuisine)', label: 'Starters Chicken(Chinese Cuisine)' },
            { key: 'Starters Seafood(Chinese Cuisine)', label: 'Starters Seafood(Chinese Cuisine)' },
            { key: 'Main Course Veg(Chinese Cuisine)', label: 'Main Course Veg(Chinese Cuisine)' },
            { key: 'MainCourse Chicken(Chinese Cuisine)', label: 'MainCourse Chicken(Chinese Cuisine)' },
            { key: 'Main Course Seafood(Chinese Cuisine)', label: 'Main Course Seafood(Chinese Cuisine)' },
            { key: 'Rice & Noodles', label: 'Rice & Noodles' },
            { key: 'Chopsuey', label: 'Chopsuey' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sanaas/sanaas-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Sanaas/sanaas-lap.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560084"],
        isShippingEnabled: true,
        restaurantPinCode: '560084'
    },
    'www.udupi-park.goyaana.com': {
        clientName: 'udupipakfooddb',
        footerLabel: 'udupi-park',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/udupi-park/udupiparklogo.jpg',
        title: 'udupi-park',
        favIconUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/udupi-park/udupiparklogo.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Southindian', label: 'Southindian' },
            { key: 'Bathspecials', label: 'Bathspecials' },
            { key: 'Breakfastcombo', label: 'Breakfastcombo' },
            { key: 'Dosa', label: 'Dosa' },
            { key: 'Meals combo', label: 'Meals combo' },
            { key: 'Indian special veg', label: 'Indian special veg' },
            { key: 'Soups', label: 'Soups' },
            { key: 'sweet', label: 'sweet' },
            { key: 'Main course', label: 'Main course' },
            { key: 'kadai specialities', label: 'kadai specialities' },
            { key: 'Breads', label: 'Breads' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Chinese straters', label: 'Chinese straters' },
            { key: 'Chinese Fried rice', label: 'Chinese Fried rice' },
            { key: 'Noodles', label: 'Noodles' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'Falooda', label: 'Falooda' },
            { key: 'Fresh fruit and Jelly', label: 'Fresh fruit and Jelly' },
            { key: 'Fresh fruit juice', label: 'Fresh fruit juice' },
            { key: 'Drinks (Beverages)', label: 'Drinks (Beverages)' },
            { key: 'Bajji And Bonda ', label: 'Bajji And Bonda' },
            { key: 'Jain Special Main Course', label: 'Jain Special Main Course' },
            { key: 'Accompaniments ', label: 'Accompaniments ' },
            { key: 'Ice Cream', label: 'Ice Creams' },
            { key: 'Milkshake', label: 'Milkshake' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/udupi-park/udupimob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/udupi-park/udupiweb.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560076"],
        isShippingEnabled: true,
        restaurantPinCode: '560076'
    },
    'www.lohiyas.goyaana.com': {
        clientName: 'lohiyasfooddb',
        footerLabel: 'lohiyas',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lohiyas/lohiyaslogo.jpg',
        title: 'lohiyas',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/savi-sagar-grand/svglogo.jpeg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Rice Combos', label: 'Rice Combos' },
            { key: 'Sabzi Specials', label: 'Sabzi Specials' },
            { key: 'Mains', label: 'Mains' },
            { key: 'Parathas', label: 'Parathas' },
            { key: 'Fried Rice and Noodles  ', label: 'Fried Rice and Noodles  ' },
            { key: 'Chinese ', label: 'Chinese ' },
            { key: 'Rolls', label: 'Rolls' },
            { key: 'Maggi', label: 'Maggi' },
            { key: 'Snacks and Chaat', label: 'Snacks and Chaat' },
            { key: 'Accompaniments', label: 'Accompaniments' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lohiyas/lohiyas-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/lohiyas/lohiyas-web.jpg'
        },
    },
    'www.sgs-gundu-palav-mobile-canteen.goyaana.com': {
        clientName: 'sgsmobilefooddb',
        footerLabel: 'SGS Gundu Palav',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/SGS.jpg',
        title: 'SGS Gundu Palav',
        favIconUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/SGS.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Chicken palav', label: 'Chicken palav' },
            { key: 'Mutton palav', label: 'Mutton palav' },
            { key: 'Plain palav', label: 'Plain palav' },
            { key: 'Kshatriya kabab', label: 'Kshatriya kabab' },
            { key: 'Kabab', label: 'Kabab' },
            { key: 'Lolipop', label: 'Lolipop' },
            { key: 'Water bottle', label: 'Water bottle' },
            { key: 'Soft drinks', label: 'Soft drinks' },
            { key: 'Parcel', label: 'Parcel' },
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/mobile.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sgsnonveg/web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560062"],
        isShippingEnabled: true,
        restaurantPinCode: '560062'
    },
    'www.marias-kitchen.goyaana.com': {
        clientName: 'mariasfooddb',
        footerLabel: 'marias-kitchen',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/mariyaslogo.jpeg',
        title: 'marias-kitchen',
        favIconUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/mariyaslogo.jpeg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Meals', label: 'Meals' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Main Course', label: 'Main Course' },
            { key: 'South Indian', label: 'South Indian' },
        ],
        landingPageImgUrl: {
            mobileImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/mariyas-mob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/mariyas-web.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560084","562125"],
        isShippingEnabled: true,
        restaurantPinCode: '560084'
    },
    'www.sri-udupi-park-hulimavu.goyaana.com': {
        clientName: 'udupiparkfooddb',
        footerLabel: 'Sri-Udupi-Park',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sri-udupi-park-hulimavu/sri-udupi-park.jpg',
        title: 'Sri-Udupi-Park',
        favIconUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sri-udupi-park-hulimavu/sri-udupi-park.jpg',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'HOT BEVERAGES', label: 'HOT BEVERAGES' },
            { key: 'SOUTH INDIAN BREAK FAST', label: 'SOUTH INDIAN BREAK FAST' },
            { key: 'SOUPS', label: 'SOUPS' },
            { key: 'DOSA', label: 'DOSA' },
            { key: 'CHINESE STARTERS', label: 'CHINESE STARTERS' },
            { key: 'NOODLES', label: 'NOODLES' },
            { key: 'NORTH INDIAN CURRIES', label: 'NORTH INDIAN CURRIES' },
            { key: 'CHINESE GRAVY', label: 'CHINESE GRAVY' },
            { key: 'CHINESE RICE', label: 'CHINESE RICE' },
            { key: 'NORTH INDIAN RICE', label: 'NORTH INDIAN RICE' },
            { key: 'SOUTH MEALS', label: 'SOUTH MEALS' },
            { key: 'NORTH MEALS', label: 'NORTH MEALS' },
            { key: 'TANDOORI SPL', label: 'TANDOORI SPL' },
            { key: 'CHATS', label: 'CHATS' },
            { key: 'MILK SHAKE', label: 'MILK SHAKE' },
            { key: 'SANDWICH', label: 'SANDWICH' },
            { key: 'CONE ICE CREAM', label: 'CONE ICE CREAM' },
            { key: 'SPL ICE CREAM', label: 'SPL ICE CREAM' },
            { key: 'FRUIT JUICE', label: 'FRUIT JUICE' },
        ],
        landingPageImgUrl: {
            mobileImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sri-udupi-park-hulimavu/udupi-mob.webp',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/sri-udupi-park-hulimavu/udupi-web.webp'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560076"],
        isShippingEnabled: true,
        restaurantPinCode: '560076'
    },
    'www.udupi-upahar-jp-nagar.goyaana.com': {
        clientName: 'upaharjpfooddb',
        footerLabel: 'Udupi-upahar',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Lucknow/new/udupi-upahar.png',
        title: 'Udupi-Upahar',
        favIconUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/Lucknow/new/udupi-upahar.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'HOT BEVERAGES', label: 'HOT BEVERAGES' },
            { key: 'SOUTH INDIAN BREAK FAST', label: 'SOUTH INDIAN BREAK FAST' },
            { key: 'DOSA SPECIALS', label: 'DOSA SPECIALS' },
            { key: 'MEALS', label: 'MEALS' },
            { key: 'SOUPS', label: 'SOUPS' },
            { key: 'PAPADS', label: 'PAPADS' },
            { key: 'CHINESE DRY', label: 'CHINESE DRY' },
            { key: 'TANDOORI DRY', label: 'TANDOORI DRY' },
            { key: 'CHINESE RICE', label: 'CHINESE RICE' },
            { key: 'TANDOORI ROTI', label: 'TANDOORI ROTI' },
            { key: 'NORTH INDIAN GRAVY', label: 'NORTH INDIAN GRAVY' },
            { key: 'KAAJU SPECIAL', label: 'KAAJU SPECIAL' },
            { key: 'DAAL SPECIAL', label: 'DAAL SPECIAL' },
            { key: 'NORTH INDIAN RICE', label: 'NORTH INDIAN RICE' }
        ],
        landingPageImgUrl: {
            mobileImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/upahar/upaharmob.jpg',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/upahar/upaharweb.jpg'
        },
        privacyPolicyLink: '',
        termsAndConditionsLink: '',
        servicablePincodes: ["560078"],
        isShippingEnabled: true,
        restaurantPinCode: '560078'
    },
};
